import React from 'react';

import Step from '../Step';
import MoldalFooter from '../MoldalFooter';

import checkForm from '../images/check-form.svg';

import '../style/prevBriefing.scss';

const QuestionData = (props) => {
	const { location } = props;

	return (
		<section className="component-briefing">
			<div className="container-begin-briefing">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<h2>Bem-vindo ao Briefing - Gearbox Mídia</h2>
						</div>
					</div>

					<div className="box-content">
						<div className="row">
							<div className="col-12">
								<div className="box-title">
									<img src={checkForm} alt="ícone formulário" className="icon-form" />
									<h3>{location.state ? location.state.data.data.attributes.pre_sale_id : ''}</h3>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-12">
								<div className="content-briefing">
									<Step />
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-12">
								<MoldalFooter />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default QuestionData;
